const oneToTenOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
const zeroToTenOptions = ['0', ...oneToTenOptions];

const leadersImmersionQuestions = (inputs) => {
  return [
    {
      text: 'Inmersión de Líderes',
      type: 'title',
    },
    {
      text: '🧍‍♂️ Datos básicos',
      type: 'title',
    },
    {
      text: 'Estado civil:',
      type: 'select',
      options: [
        'Casad@',
        'Casad@ en familia compuesta (matrimonio con hijos de ambas partes de relaciones anteriores)',
        'Solter@',
        'Viud@',
        'Separad@',
      ],
      id: 'basic_marital_status',
    },
    ...(inputs.basic_marital_status === 'Separad@' ||
    inputs.basic_marital_status === 'Viud@' ||
    inputs.basic_marital_status?.includes?.('Casad@')
      ? [
          {
            text: 'Si respondió Separado, Viudo o Casado, por favor indique hace cuanto tiempo en años',
            type: 'input',
            kind: 'number',
            min: 0,
            id: 'basic_time_status',
          },
        ]
      : []),
    {
      text: 'Escribe el número de tus hijos al frente de cada opción según lo que corresponda',
      type: 'text',
      class: 'children-ages-section',
    },
    {
      text: 'a. Bebés (de 0 a 2 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_babies',
    },
    {
      text: 'b. Niños primera infancia (2 a 6 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_early',
    },
    {
      text: 'c. Niños segunda infancia (7 a 11 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_middle',
    },
    {
      text: 'd. Prejuventud (12 a 14 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_pre_youth',
    },
    {
      text: 'e. Juventud (15 a 21 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_youth',
    },
    {
      text: 'f. Adultes Joven (22 a 30 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_young_adult',
    },
    {
      text: 'g. Adultos (Más de 30 años)',
      type: 'select',
      options: zeroToTenOptions,
      id: 'basic_children_adult',
    },
    {
      text: '¿Hace cuánto conoces a Jesús?',
      type: 'select',
      options: [
        '0 a 3 años',
        '3 a 5 años',
        '5 a 10 años',
        '10 a 15 años',
        '15 a 20 años',
        'Más de 20 años',
      ],
      id: 'basic_know_jesus',
    },
    {
      text: 'Anteriormente a Comunidad perteneciste a otras iglesias cristianas?',
      type: 'select',
      options: ['Sí', 'No'],
      id: 'basic_previous_church',
    },
    ...(inputs.basic_previous_church === 'Sí'
      ? [
          {
            text: 'Respondiste SI he pertenecido a otra iglesia Cristiana, escribe cual (es).',
            type: 'input',
            id: 'basic_previous_church_name',
          },
        ]
      : []),
    {
      text: '¿Hace cuánto haces parte de Comunidad?',
      type: 'select',
      options: [
        '0 a 3 años',
        '3 a 5 años',
        '5 a 10 años',
        '10 a 15 años',
        '15 a 20 años',
        'Más de 20 años',
      ],
      id: 'basic_time_community',
    },
    {
      text: 'Ocupación actual:',
      type: 'select',
      options: [
        'En búsqueda de empleo',
        'Ama de casa',
        'Encargado de las labores del hogar',
        'Jubilado',
        'Educación y formación (Docentes, orientadores, formadores, coaches, pedagogos)',
        'Salud y bienestar (Médicos, enfermeros, psicólogos, terapeutas, cuidadores)',
        'Ciencias sociales y humanidades (Trabajadores sociales, abogados, comunicadores, sociólogos, antropólogos)',
        'Ciencias económicas y administrativas (Administradores, contadores, economistas, financieros, auditores)',
        'Tecnología e informática (Ingenieros de sistemas, programadores, técnicos en redes, ciberseguridad)',
        'Ingenierías y construcción (Ingenieros civiles, industriales, arquitectos, técnicos en obras)',
        'Ciencias naturales y exactas (Biólogos, químicos, físicos, matemáticos)',
        'Artes y creatividad (Músicos, artistas visuales, diseñadores gráficos, escritores)',
        'Servicio al cliente y ventas (Asesores comerciales, vendedores, ejecutivos de cuenta, atención al cliente)',
        'Otra',
      ],
      id: 'basic_occupation',
    },
    ...(inputs.basic_occupation === 'En búsqueda de empleo'
      ? [
          {
            text: 'Respondiste en Busqueda de empleo, por favor especifica en que área de ocupación:',
            type: 'select',
            options: [
              'Educación y formación (Docentes, orientadores, formadores, coaches, pedagogos)',
              'Salud y bienestar (Médicos, enfermeros, psicólogos, terapeutas, cuidadores)',
              'Ciencias sociales y humanidades (Trabajadores sociales, abogados, comunicadores, sociólogos, antropólogos)',
              'Ciencias económicas y administrativas (Administradores, contadores, economistas, financieros, auditores)',
              'Tecnología e informática (Ingenieros de sistemas, programadores, técnicos en redes, ciberseguridad)',
              'Ingenierías y construcción (Ingenieros civiles, industriales, arquitectos, técnicos en obras)',
              'Ciencias naturales y exactas (Biólogos, químicos, físicos, matemáticos)',
              'Artes y creatividad (Músicos, artistas visuales, diseñadores gráficos, escritores)',
              'Servicio al cliente y ventas (Asesores comerciales, vendedores, ejecutivos de cuenta, atención al cliente)',
              'Gestión del talento humano (Psicólogos organizacionales, reclutadores, formadores internos, líderes de desarrollo)',
              'Sector público y comunitario (Funcionarios públicos, gestores sociales, líderes comunitarios)',
              'Emprendimiento y liderazgo empresarial (Empresarios, fundadores, autónomos, gestores de proyectos propios)',
              'Oficios técnicos y operativos (Conductores, electricistas, mecánicos, operarios de planta, personal logístico)',
            ],
            id: 'basic_job_search_area',
          },
        ]
      : []),
    ...(inputs.basic_occupation === 'Otra'
      ? [
          {
            text: 'Respondiste Otra área, dinos cual.',
            type: 'input',
            id: 'basic_other_occupation',
          },
        ]
      : []),

    {
      text: '🙏 Dimensión espiritual',
      type: 'title',
    },
    {
      text: '¿Cuál es tu experiencia previa liderando grupos o discipulados?',
      type: 'select',
      options: ['Menos de 1 año', '1-3 años', '3-5 años', '5 a 10 años', 'Más de 10 años'],
      id: 'spiritual_leadership_experience',
    },
    {
      text: '¿Qué prácticas espirituales disfrutas más?',
      class: 'checkbox-container',
      type: 'checkbox',
      multiple: true,
      options: ['Oración', 'Estudio bíblico', 'Alabanza', 'Servicio', 'Ayuno', 'Consejería'],
      id: 'spiritual_practices',
    },
    {
      text: '¿Con qué grupos te sientes más llamado o cómodo acompañando?',
      class: 'checkbox-container',
      type: 'checkbox',
      multiple: true,
      options: ['Nuevos creyentes', 'Jóvenes', 'Mujeres', 'Hombres', 'Matrimonios'],
      id: 'spiritual_group_preference',
    },

    {
      text: '🗣️ Estilo relacional y de liderazgo',
      type: 'title',
    },
    {
      text: '¿Cómo describirías tu estilo de liderazgo?',
      type: 'select',
      options: ['Acompañante', 'Mentor', 'Enseñante', 'Pastor', 'Motivador', 'Impulsor'],
      id: 'leadership_style',
    },
    {
      text: '¿Te sientes cómodo confrontando en amor cuando es necesario?',
      type: 'select',
      options: ['Sí', 'No', 'Depende de la situación'],
      id: 'leadership_confrontation',
    },
    {
      text: '¿Qué valoras más en una relación de discipulado?',
      type: 'select',
      options: [
        'Confianza',
        'Transparencia',
        'Compromiso',
        'Crecimiento espiritual',
        'Escucha activa',
      ],
      id: 'leadership_values',
    },
    {
      text: '¿Desde el discipulado que nivel consideras que tienes actualmente? Coloca al frente una autovaloración de 1 a 10 según tu llamado y avance en madurez',
      type: 'text',
      class: 'leadership-assessment',
    },
    {
      text: 'a. Evangelístico: Compasión para atraer nuevas almas (testimonio)',
      type: 'select',
      id: 'leadership_evangelistic',
      kind: 'number',
      options: oneToTenOptions,
    },
    {
      text: 'b. Profético: Sensibilidad para escuchar la voz de Dios',
      type: 'select',
      id: 'leadership_prophetic',
      kind: 'number',
      options: oneToTenOptions,
    },
    {
      text: 'c. Maestro: Conocimiento bíblico',
      type: 'select',
      id: 'leadership_teacher',
      kind: 'number',
      options: oneToTenOptions,
    },
    {
      text: 'd. Pastoral: El cuidado y guía con el carácter de Cristo',
      type: 'select',
      id: 'leadership_pastoral',
      kind: 'number',
      options: oneToTenOptions,
    },
    {
      text: 'e. Apostólico: Madurez para integrar y consolidar iglesia',
      type: 'select',
      id: 'leadership_apostolic',
      kind: 'number',
      options: oneToTenOptions,
    },

    {
      text: '⏰ Disponibilidad',
      type: 'title',
    },
    {
      text: '¿Cuántas personas podrías acompañar en discipulado? (Revisa muy bien tus tiempos de familia, cuidado de ti y atención a tus discípulos)',
      type: 'select',
      options: ['Hasta 5 personas', 'De 5 a 10 personas', 'De 10 a 15 personas'],
      id: 'availability_people_count',
    },
    {
      text: '¿Con qué frecuencia te reúnes?',
      type: 'select',
      options: ['Semanal', 'Quincenal', 'Mensual'],
      id: 'availability_frequency',
    },
    {
      text: '¿Cuál es tu disponibilidad de horario para las reuniones?',
      type: 'select',
      options: ['Mañanas', 'Tardes', 'Noches', 'Fines de semana'],
      id: 'availability_schedule',
    },
    {
      text: '¿Prefieres encuentros presenciales, virtuales o ambos?',
      type: 'select',
      options: ['Presencial', 'Virtual', 'Ambos'],
      id: 'availability_meeting_type',
    },

    {
      text: '💬 Afinidad y estilo de comunicación',
      type: 'title',
    },
    {
      text: '¿Qué tipo de conversaciones se te dan con más fluidez?',
      type: 'select',
      options: ['Profundas', 'Prácticas', 'Espirituales', 'Cotidianas', 'Motivacionales'],
      id: 'communication_conversation_type',
    },
    {
      text: '¿En que temas das testimonio de sanidad y/o puedes conectar por experiencia propia, familiar o tu capacitación profesional? Puedes colocar cuantas consideres',
      type: 'checkbox',
      multiple: true,
      class: 'checkbox-container',
      options: [
        'Familias recompuestas',
        'Sanidad física',
        'Sanidad mental',
        'Empresarios o emprendedores',
        'Amistad',
        'Aborto',
        'Maltrato o abandono familiar',
        'Pornografía',
        'Alcoholismo',
        'Drogadicción',
        'Adulterio',
        'Fornicación y ataduras sexuales',
        'Oscurantismo',
        'Teología Cristiana',
        'Familias con yugo desigual',
        'Sanidad financiera',
        'Relaciones sanas',
        'Familia y crianza',
        'Identidad de genero',
      ],
      id: 'communication_testimony_topics',
    },
    {
      text: '¿Qué intereses tienes de la vida cotidiana? Coloca todos los que te apliquen',
      type: 'checkbox',
      multiple: true,
      class: 'checkbox-container',
      options: [
        'Familia y crianza de hijos',
        'Matrimonio y relaciones de pareja',
        'Soltería con propósito',
        'Jóvenes y adolescencia',
        'Emprendimiento y trabajo',
        'Finanzas personales',
        'Salud física y bienestar integral',
        'Inteligencia emocional',
        'Lectura y escritura',
        'Arte y creatividad',
        'Música y expresión artística',
        'Naturaleza y actividades al aire libre',
        'Tecnología y redes sociales',
        'Deportes y actividad física',
      ],
      id: 'communication_daily_interests',
    },
  ];
};

export { leadersImmersionQuestions };
